import * as React from 'react';
import { Container } from 'types/Watchlist';
import { CellProps } from './types';
import { DualCell } from './DualCell';

export const DeletedBy: React.FC<CellProps> = (props) => {
  const container = props.row as Container;
  return <DualCell topText={container.deletedBy || 'Deleted user'} />;
};
DeletedBy.displayName = 'Shipments.Table.Cells.DeletedBy';
